export default "__VITE_ASSET__uSdVe2tT__"